import { Grid } from '@mui/material';
import { Step, Count, Text } from './Steps.styles';

interface StepProps {
  steps: string[];
}

const Steps = ({ steps }: StepProps) => (
  <Grid container spacing={1}>
    {steps.map((step: string, idx: number) => (
      <Grid key={`step-${idx + 1}`} item xs={12} sm={6}>
        <Step aria-label="Purchase step">
          <Count>{idx + 1}</Count>
          <Text variant="body2">{step}</Text>
        </Step>
      </Grid>
    ))}
  </Grid>
);

export default Steps;
